var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveDebts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 0C8.28125 0 7.10938 1.17188 7.10938 2.57812V34.9219C7.10938 35.7031 6.48438 36.3281 5.70313 36.3281C4.92188 36.3281 4.29688 35.7031 4.29688 34.9219V5.625H3.125V34.9219C3.125 36.3281 4.29688 37.5 5.70313 37.5C7.10938 37.5 8.28125 36.3281 8.28125 34.9219V2.57812C8.28125 1.79688 8.90625 1.17188 9.6875 1.17188C10.4687 1.17188 11.0938 1.79688 11.0938 2.57812V46.25L15.1562 50L18.5937 46.7969L22.0312 50L25.4687 46.7969L28.9062 50L32.3438 46.7969L35.9375 50L39.375 46.7969L42.8125 50L46.875 46.25V0H9.6875ZM45.7812 45.7812L42.8906 48.4375L39.4531 45.2344L35.9375 48.4375L32.5 45.2344L28.9844 48.4375L25.5469 45.2344L22.1094 48.4375L18.6719 45.2344L15.1562 48.4375L12.2656 45.7812V2.57812C12.2656 2.03125 12.1094 1.5625 11.7969 1.17188H45.7031V45.7812H45.7812Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 5H15.5469V6.17188H42.1875V5Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 8.98438H15.5469V10.1562H42.1875V8.98438Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 12.8906H15.5469V14.0625H42.1875V12.8906Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 16.875H32.2656V18.0469H33.4375V16.875Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 16.875H22.7344V18.0469H23.9062V16.875Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16.875H25.0781V18.0469H26.25V16.875Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6719 16.875H27.5V18.0469H28.6719V16.875Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0156 16.875H29.8438V18.0469H31.0156V16.875Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 16.875H15.5469V18.0469H16.7188V16.875Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 16.875H17.8906V18.0469H19.0625V16.875Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4844 16.875H20.3125V18.0469H21.4844V16.875Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2031 16.875H37.0312V18.0469H38.2031V16.875Z",
    fill: "#666666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 16.875H41.875V18.0469H42.1875V16.875Z",
    fill: "#666666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8594 16.875H34.6875V18.0469H35.8594V16.875Z",
    fill: "#666666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 16.875H39.4531V18.0469H40.625V16.875Z",
    fill: "#666666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5156 20.7812H15.5469V21.9531H33.5156V20.7812Z",
    fill: "#666666"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3906 31.0938C35.625 31.3281 35.7812 31.5625 35.7812 31.875H36.9531C36.9531 31.25 36.6406 30.7031 36.1719 30.2344C35.8594 29.9219 35.3906 29.7656 35 29.6875V28.3594H33.8281V29.6875C33.3594 29.7656 32.9688 29.9219 32.6562 30.2344C32.1875 30.7031 31.875 31.25 31.875 31.875C31.875 32.5 32.1875 33.0469 32.6562 33.5156C33.125 33.9063 33.75 34.1406 34.4531 34.1406C34.8437 34.1406 35.2344 34.2969 35.4688 34.5313C35.7031 34.7656 35.8594 35 35.8594 35.3125C35.8594 35.625 35.7031 35.8594 35.4688 36.0938C34.9219 36.5625 33.9844 36.5625 33.4375 36.0938C33.2031 35.8594 33.0469 35.625 33.0469 35.3125H31.875C31.875 35.9375 32.1875 36.4844 32.6562 36.9531C32.9688 37.2656 33.4375 37.4219 33.8281 37.5V38.75H35V37.5C35.4688 37.4219 35.8594 37.1875 36.1719 36.9531C36.6406 36.4844 36.9531 35.9375 36.9531 35.3125C36.9531 34.6875 36.6406 34.1406 36.1719 33.6719C35.7031 33.2812 35.0781 33.0469 34.375 33.0469C33.9844 33.0469 33.5938 32.8906 33.3594 32.6562C33.125 32.4219 32.9688 32.1875 32.9688 31.875C32.9688 31.5625 33.125 31.3281 33.3594 31.0938C33.8281 30.625 34.8438 30.625 35.3906 31.0938Z",
    fill: "#666666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1719 41.7969H42.5781V25.3906H26.1719V41.7969ZM27.2656 26.5625H41.4062V40.625H27.2656V26.5625Z",
    fill: "#666666"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 7.26562H9.14062V8.4375H10.3125V7.26562Z",
    fill: "#666666"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 9.60938H9.14062V10.7812H10.3125V9.60938Z",
    fill: "#666666"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 4.84375H9.14062V6.01562H10.3125V4.84375Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDebts);
export default __webpack_public_path__ + "static/media/activeDebts.d21a22a9cf0048a85be86c1757997914.svg";
export { ForwardRef as ReactComponent };